<template>
  <div class="designlist">
    <h1>Create Design</h1>

    <br />
    <br />
    <br />
    <b-container class="bv-example-row">
      <b-form @submit="postDesign">
        <b-form-group id="input-group-1" label="Design name:" label-for="input-1">
          <b-form-input id="input-1" v-model="designName" type="text" required placeholder></b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">Create</b-button>
      </b-form>
      <br />
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DesignAdd",
  data() {
    return {
      designName: "",
    };
  },
  methods: {
    postDesign(e) {
      e.preventDefault();
      axios
        .post(process.env.VUE_APP_API_SERVER.concat("/v1/designs"), {
          name: this.designName,
        })
        .then((response) => console.log(response.data))
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },
    mounted() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>